<script>
    import { onMount } from 'svelte';
    import SimpleStream from './SimpleStream.svelte';
    import NowPlayingControl from './NowPlayingControl.svelte';

    let nowPlaying = {};

    $: nowPlayingData = streams.filter((el) => el.name === nowPlaying.name)[0];

    const streams = [
        {
            name: 'Red 93.1 FM',
            url: 'http://ice24.securenetsystems.net/CKYE',
            image: '/assets/ckyefm.png',
        },
        {
            name: 'KRPI 1550 AM',
            url: 'http://playerservices.streamtheworld.com/api/livestream-redirect/KRPIAM_SC',
            image: '/assets/krpiam.jpg',
        },
        {
            name: 'gurU nwnk is`K gurUdvwrw',
            language: 'punjabi',
            english_name: 'Guru Nanak Sikh Gurdwara',
            url: 'http://s5.voscast.com:7370/;stream.mp3',
            image: '/assets/gnsg.png',
        },
        {
            name: 'dUK invwrn',
            language: 'punjabi',
            english_name: 'Dukh Nivaran',
            url: 'http://radio2.sikhnet.com:8037/live',
            image: '/assets/dukh_nivaran.jpg',
        },
        {
            name: 'dSmyS drbwr',
            language: 'punjabi',
            english_name: 'Dashmesh Darbar',
            url: 'http://s5.voscast.com:7316/stream',
            image: '/assets/dashmesh.png',
        },
        {
            name: 'AKMf pwT',
            language: 'punjabi',
            english_name: 'Akhand Paath',
            url: 'http://radio2.sikhnet.com:8018/autodj',
            image: '/assets/akhand_paath.jpg',
        },
        {
            name: 'Sbd kIrqn 1',
            language: 'punjabi',
            english_name: 'Shabad Kirtan 1',
            url: 'http://janus.shoutca.st:8195/start.mp3',
            image: '/assets/kirtan.jpg',
        },
        {
            name: 'Sbd kIrqn 2',
            language: 'punjabi',
            english_name: 'Shabad Kirtan 2',
            url: 'http://radio2.sikhnet.com:8010/live',
            image: '/assets/kirtan.jpg',
        },
        {
            name: 'Sbd kIrqn 3',
            language: 'punjabi',
            english_name: 'Shabad Kirtan 3',
            url: 'http://radio2.sikhnet.com:8014/live',
            image: '/assets/kirtan.jpg',
        },
    ]

    onMount(() => {
        if ('mediaSession' in navigator) {
            navigator.mediaSession.setActionHandler('pause', () => {
                handleStop();
            })
        }
    })

    function handleStartedPlaying(event) {
        handleStop();
        const playingStreamData = streams.filter((el) => el.name === event.detail.name)[0];
        console.log(playingStreamData);
        nowPlaying = event.detail;

        if ('mediaSession' in navigator) {
            navigator.mediaSession.metadata = new MediaMetadata({
                title: playingStreamData.english_name || playingStreamData.name,
                artwork: [{ src: playingStreamData.image }]
            });
        }
    }

    function handleStop(event) {
        if (nowPlaying.name) {
            nowPlaying.stop();
        }
        nowPlaying = {};
    }
</script>

<style>
    .page-title {
        font-family: Amrlipi;
        padding-bottom: 16px;
        font-size: 2em;
    }

	.list-container {
        padding: 16px;
        padding-bottom: 86px;
        margin: 0 auto;
        max-width: 800px;
	}

    main {
        display: flex;
    }
</style>

<main>
    <div class="list-container">
        <div class="page-title">
            pMjwbI ryfIE
        </div>

        {#each streams as stream (stream.name)}
            <SimpleStream {...stream} on:startedPlaying={handleStartedPlaying}/>
        {/each}
    </div>

    {#if nowPlaying.name}
        <NowPlayingControl on:stopClicked={handleStop} {...nowPlayingData}/>
    {/if}
</main>
